// assets/uc-cart-bonus.js
(() => {
  const FREE_VARIANT_ID = 52560709550359;
  const PAID_VARIANT_ID = 52560709583127;

  const DIGITAL_POSTER_PRODUCT_IDS = [
    10225500881175,
    10225104748823,
    10226935988503,
    10226936807703,
    10226935169303
  ];

  let ucBonusBusy = false;
  let ucPresenceTimer = null;

  function log(...args) {
    console.log('[UC BONUS]', ...args);
  }

  async function getCart() {
    return window.UCCartDrawerSync.getCart();
  }

  async function changeLineByKey(key, quantity, openDrawer = true) {
    return window.UCCartDrawerSync.changeLine(key, quantity, { openDrawer });
  }

  async function updateCart(updates, openDrawer = true) {
    return window.UCCartDrawerSync.updateCart(updates, { openDrawer });
  }

  async function addPaidVariant(quantity, openDrawer = true) {
    if (quantity <= 0) return null;

    return window.UCCartDrawerSync.addItems(
      [{ id: PAID_VARIANT_ID, quantity }],
      { openDrawer }
    );
  }

  function getLineByVariant(cart, variantId) {
    return (cart.items || []).find(
      (item) => Number(item.variant_id) === Number(variantId)
    );
  }

  function cartHasEligiblePoster(cart) {
    return (cart.items || []).some((item) =>
      DIGITAL_POSTER_PRODUCT_IDS.includes(Number(item.product_id))
    );
  }

  function showBonusMessage(msg) {
    log(msg);

    let el = document.getElementById('uc-bonus-msg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'uc-bonus-msg';
      el.style.position = 'fixed';
      el.style.bottom = '20px';
      el.style.right = '20px';
      el.style.zIndex = '9999';
      el.style.background = '#111';
      el.style.color = '#fff';
      el.style.padding = '12px 16px';
      el.style.borderRadius = '10px';
      el.style.boxShadow = '0 8px 30px rgba(0,0,0,.35)';
      el.style.maxWidth = '320px';
      el.style.fontSize = '14px';
      document.body.appendChild(el);
    }

    el.textContent = msg;
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(() => el.remove(), 3000);
  }

  function getCheckoutButtons(root = document) {
    return Array.from(
      root.querySelectorAll(
        'button[name="checkout"], button[data-checkout], form[action="/cart"] button[type="submit"]'
      )
    );
  }

  function setCheckoutLocked(locked) {
    getCheckoutButtons().forEach((el) => {
      if (el.tagName === 'BUTTON') {
        el.disabled = locked;
      }
    });
  }

  function queuePresenceCheck(showMessage = false, delay = 250) {
    clearTimeout(ucPresenceTimer);
    ucPresenceTimer = setTimeout(() => {
      enforceBonusPresenceRule(showMessage);
    }, delay);
  }

  function isPlusButton(btn) {
    if (!btn) return false;

    const name = (btn.getAttribute('name') || '').toLowerCase();
    const aria = (btn.getAttribute('aria-label') || '').toLowerCase();
    const text = (btn.textContent || '').trim();

    return (
      name.includes('plus') ||
      aria.includes('increase') ||
      aria.includes('increment') ||
      text === '+'
    );
  }

  function isMinusButton(btn) {
    if (!btn) return false;

    const name = (btn.getAttribute('name') || '').toLowerCase();
    const aria = (btn.getAttribute('aria-label') || '').toLowerCase();
    const text = (btn.textContent || '').trim();

    return (
      name.includes('minus') ||
      aria.includes('decrease') ||
      aria.includes('decrement') ||
      text === '-'
    );
  }

  function rowLooksLikeFreeBonus(row) {
    if (!row) return false;
    const html = (row.innerHTML || '').toLowerCase();

    return (
      html.includes(String(FREE_VARIANT_ID)) ||
      html.includes('bonus-free') ||
      html.includes(`variant=${FREE_VARIANT_ID}`) ||
      html.includes('/products/1-000-bonus-pack') ||
      html.includes('1,000 bonus pack') ||
      html.includes('1-000 bonus pack')
    );
  }

  function getRowFromButton(btn) {
    return btn.closest('tr, cart-item, .cart-item, .drawer__cart-item, .cart-drawer__item, li');
  }

  async function removeFreeIfNoPoster(cart = null, showMessage = false) {
    const currentCart = cart || await getCart();
    const freeLine = getLineByVariant(currentCart, FREE_VARIANT_ID);

    if (!freeLine) return false;
    if (cartHasEligiblePoster(currentCart)) return false;

    await changeLineByKey(freeLine.key, 0, true);

    if (showMessage) {
      showBonusMessage('Bonus pack removed because no digital poster pack is in your cart.');
    }

    return true;
  }

  async function enforceBonusPresenceRule(showMessage = false) {
    if (ucBonusBusy) return false;

    const cart = await getCart();
    const freeLine = getLineByVariant(cart, FREE_VARIANT_ID);
    if (!freeLine) return false;

    ucBonusBusy = true;
    setCheckoutLocked(true);

    try {
      return await removeFreeIfNoPoster(cart, showMessage);
    } catch (err) {
      console.error('[UC BONUS] enforceBonusPresenceRule failed:', err);
      return false;
    } finally {
      ucBonusBusy = false;
      setCheckoutLocked(false);
    }
  }

  async function addOnePaidAndClampFree() {
    if (ucBonusBusy) return;
    ucBonusBusy = true;
    setCheckoutLocked(true);

    try {
      const cart = await getCart();
      const freeLine = getLineByVariant(cart, FREE_VARIANT_ID);

      if (!freeLine) return;

      if (!cartHasEligiblePoster(cart)) {
        await changeLineByKey(freeLine.key, 0, true);
        showBonusMessage('Add a digital poster pack to your cart first.');
        return;
      }

      if (Number(freeLine.quantity || 0) !== 1) {
        await changeLineByKey(freeLine.key, 1, false);
      }

      await addPaidVariant(1, true);
    } catch (err) {
      console.error('[UC BONUS] addOnePaidAndClampFree failed:', err);
    } finally {
      ucBonusBusy = false;
      setCheckoutLocked(false);
    }
  }

  async function enforceFreeInputClamp(input) {
    if (ucBonusBusy) return;

    const row = input.closest('tr, cart-item, .cart-item, .drawer__cart-item, .cart-drawer__item, li');
    if (!rowLooksLikeFreeBonus(row)) return;

    const desired = Number(input.value || 0);

    if (desired <= 1) {
      input.value = 1;
      input.setAttribute('value', '1');
      return;
    }

    input.value = 1;
    input.setAttribute('value', '1');

    ucBonusBusy = true;
    setCheckoutLocked(true);

    try {
      const cart = await getCart();
      const freeLine = getLineByVariant(cart, FREE_VARIANT_ID);

      if (!cartHasEligiblePoster(cart)) {
        if (freeLine) {
          await changeLineByKey(freeLine.key, 0, true);
        }
        showBonusMessage('Add a digital poster pack to your cart first.');
        return;
      }

      const overflow = desired - 1;

      if (freeLine && Number(freeLine.quantity || 0) !== 1) {
        await changeLineByKey(freeLine.key, 1, false);
      }

      await addPaidVariant(overflow, true);
    } catch (err) {
      console.error('[UC BONUS] enforceFreeInputClamp failed:', err);
    } finally {
      ucBonusBusy = false;
      setCheckoutLocked(false);
    }
  }

  function isProductForm(form) {
    return !!form && (
      form.matches('form[action*="/cart/add"]') ||
      form.querySelector('input[name="id"], select[name="id"]')
    );
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!idInput) return null;
    return Number(idInput.value || 0) || null;
  }

  async function interceptProductFormAdd(form, e) {
    if (ucBonusBusy) return true;

    const variantId = getVariantIdFromForm(form);
    if (variantId !== FREE_VARIANT_ID) return false;

    const cart = await getCart();
    const freeLine = getLineByVariant(cart, FREE_VARIANT_ID);
    const hasPoster = cartHasEligiblePoster(cart);

    if (!hasPoster) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      showBonusMessage('Add a digital poster pack to your cart first.');
      return true;
    }

    if (!freeLine) {
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    ucBonusBusy = true;
    setCheckoutLocked(true);

    try {
      await addPaidVariant(1, true);
      return true;
    } catch (err) {
      console.error('[UC BONUS] interceptProductFormAdd failed:', err);
      return true;
    } finally {
      ucBonusBusy = false;
      setCheckoutLocked(false);
    }
  }

  function bindQuantityButtons(root = document) {
    root.querySelectorAll('quantity-input button').forEach((btn) => {
      if (btn.dataset.ucBonusBound === '1') return;
      btn.dataset.ucBonusBound = '1';

      btn.addEventListener(
        'click',
        async (e) => {
          const row = getRowFromButton(btn);
          if (!rowLooksLikeFreeBonus(row)) return;

          if (isPlusButton(btn)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            await addOnePaidAndClampFree();
            return;
          }

          if (isMinusButton(btn)) {
            const input = row.querySelector('input[name="updates[]"]');
            if (input) {
              setTimeout(() => {
                if (Number(input.value || 0) < 1) {
                  input.value = 1;
                  input.setAttribute('value', '1');
                }
              }, 0);
            }
          }
        },
        true
      );
    });
  }

  function bindQuantityInputs(root = document) {
    root.querySelectorAll('input[name="updates[]"]').forEach((input) => {
      if (input.dataset.ucBonusBound === '1') return;
      input.dataset.ucBonusBound = '1';

      input.addEventListener('change', () => {
        enforceFreeInputClamp(input);
      });

      input.addEventListener('blur', () => {
        enforceFreeInputClamp(input);
      });
    });
  }

  function bindProductForms(root = document) {
    root.querySelectorAll('form').forEach((form) => {
      if (!isProductForm(form)) return;
      if (form.dataset.ucBonusFormBound === '1') return;

      form.dataset.ucBonusFormBound = '1';

      form.addEventListener(
        'submit',
        async (e) => {
          await interceptProductFormAdd(form, e);
        },
        true
      );
    });
  }

  function bindPosterRemovalWatchers(root = document) {
    root.querySelectorAll('cart-remove-button a, cart-remove-button button, a[href*="/cart/change"], button[name="minus"], quantity-input button').forEach((el) => {
      if (el.dataset.ucPosterWatchBound === '1') return;
      el.dataset.ucPosterWatchBound = '1';

      el.addEventListener('click', () => {
        queuePresenceCheck(true, 350);
      });
    });

    root.querySelectorAll('input[name="updates[]"]').forEach((input) => {
      if (input.dataset.ucPosterInputBound === '1') return;
      input.dataset.ucPosterInputBound = '1';

      input.addEventListener('change', () => {
        queuePresenceCheck(true, 350);
      });
    });
  }

  function blockCheckoutWhileBusy() {
    document.addEventListener(
      'click',
      (e) => {
        const target = e.target.closest(
          'button[name="checkout"], button[data-checkout], form[action="/cart"] button[type="submit"]'
        );
        if (!target) return;

        if (ucBonusBusy) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function boot(root = document) {
    bindQuantityButtons(root);
    bindQuantityInputs(root);
    bindProductForms(root);
    bindPosterRemovalWatchers(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.UCCartDrawerSync) return;

    boot(document);
    blockCheckoutWhileBusy();
    queuePresenceCheck(false, 300);
  });

  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof HTMLElement) {
          boot(node);
          shouldCheck = true;
        }
      }
    }

    if (shouldCheck) {
      queuePresenceCheck(false, 300);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();